<template>
  <v-container>
    <v-row>
      <v-col>
        <WorkflowPicker
          title="Workflow"
          v-model="value.workflow"
          :is-required="true"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <WorkflowParamsEditor
          title="Parameters"
          :table="table"
          v-model="value.params"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <DataOutputPicker title="Save output to" v-model="value.output" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WorkflowPicker from "../../workflow/shared/WorkflowPicker.vue";
import WorkflowParamsEditor from "../../workflow/shared/WorkflowParamsEditor.vue";
import DataOutputPicker from "../shared/DataOutputPicker.vue";

export default {
  name: "RunWorkflowDesigner",

  components: { WorkflowPicker, DataOutputPicker, WorkflowParamsEditor },

  props: ["value", "containers", "table", "component"],
};
</script>
